
import { getEmissionData, getEmissionFootnotes, getEngineDescription } from '../utils/technicalData';
import { Product } from '@dh-io-emh/search-result-store';
import { useFootnoteReference } from '@dh-io-emh/footnotes/src/utils/footnote-reference.helper';
import { computed, defineComponent, PropType, toRefs } from 'vue';
import { TFunction } from 'i18next';

export default defineComponent({
  name: 'EmhAdditionalData',
  props: {
    slotName: {
      type: String,
      required: true,
    },
    t: {
      type: Function as PropType<TFunction>,
      required: true,
    },
    product: {
      type: Object as PropType<Product>,
      required: true,
    },
    language: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { product, t, language } = toRefs(props);
    const engineDescription = getEngineDescription(product.value, t.value);
    const emissionData = getEmissionData(product.value);
    const emissionFootnotes = getEmissionFootnotes(product.value)?.[language.value];
    const fuelType = computed(() => product.value.fuelType?.name ?? '');
    const { generateReference } = useFootnoteReference('additionalData');

    return {
      fuelType,
      engineDescription,
      emissionData,
      emissionFootnotes,
      generateReference,
    };
  },
});
